import { render } from "./credit_management.html?vue&type=template&id=20f15160&external"
import script from "./credit_management.js?vue&type=script&lang=js&external"
export * from "./credit_management.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__